// extracted by css-extract-rspack-plugin
export default {"dropdownIndicator":"Select__dropdownIndicator--ZadAq"};